export enum EDocumentsStatus {
  ARCHIVED = 'archived',
  CANCELED = 'canceled',
  DRAFT = 'draft',
  EXPIRED = 'expired',
  PENDING = 'pending',
  PENDING_APPROVAL = 'pending_approval',
  REJECTED = 'rejected',
  SIGNED = 'signed',
}

export enum EApprovalStatus {
  PENDING = 'pending',
  APPROVED = 'approved',
  REJECTED = 'rejected',
}

export enum ESignatureType {
  SIMPLE = 'simple',
  SIMPLEX = 'simplex',
  ADVANCED = 'advanced',
  DACTILAR = 'dactilar',
  FACIAL = 'facial',
}

export enum ESignStatus {
  PENDING = 'pending',
  SIGNED = 'signed',
  REJECTED = 'rejected',
  EXPIRED = 'expired',
}

export enum EFieldType {
  SIGNATURE = 'signature',
  TEXT = 'text',
  FILE = 'file',
}

/**
 * Estado del rasterizado de las páginas del PDF.
 *
 * Es un eje SEPARADO de `EDocumentsStatus`, no un valor más dentro de él:
 * `EDocumentsStatus` dice dónde está el documento en el flujo de firma
 * (borrador → pendiente → firmado), esto dice si el archivo ya es utilizable.
 * Un documento puede ser borrador y estar listo, o borrador y estar todavía
 * procesándose. Mezclarlos obligaría a tocar todos los filtros y reportes.
 */
export enum EDocumentRenderStatus {
  PENDING = 'PENDING',
  PROCESSING = 'PROCESSING',
  READY = 'READY',
  FAILED = 'FAILED',
}

/** Los dos estados en los que el documento existe pero aún no se puede usar. */
export const DOCUMENT_RENDER_IN_PROGRESS: readonly EDocumentRenderStatus[] = [
  EDocumentRenderStatus.PENDING,
  EDocumentRenderStatus.PROCESSING,
];

/**
 * Un documento sin `renderStatus` se trata como listo.
 *
 * Importa: todos los documentos creados antes de esta feature vienen sin el
 * campo, y la columna nace con `DEFAULT 'READY'`. Asumir lo contrario dejaría
 * el histórico entero marcado como "procesando".
 */
export const isDocumentRenderReady = (renderStatus?: EDocumentRenderStatus | null): boolean =>
  !renderStatus || renderStatus === EDocumentRenderStatus.READY;
